import React from 'react'
import './section3.css'
import sec3img from './images/sec3-img.jpg';
import { Link } from 'react-router-dom';

const section3 = () => {
  return (
    <div className='section3'>
      <div className='sec3-div'>
<div className='sec3-left'>
<img src={sec3img} alt=''/>
</div>
<div className='sec3-right'>
<div className='sec3-right-div'>
  <h1><span className="highlight">Build Skills to Fight Real Cyber Threats</span>& Protect the Digital World</h1>
 <p> Learn cybersecurity the way professionals actually do it — through real labs, live attack simulations, and tools used by security teams worldwide. Whether you're just starting out or looking to level up your career, our cybersecurity program teaches you through real-world simulations, hands-on labs, and tools that professionals actually use.</p>
 {/* <a href=''> */}
 <Link to="/CoursesFile">
 <button>Become Cyber Ready</button>
 </Link>
 {/* </a> */}
</div>
</div>
      </div>
    </div>
  )
}

export default section3
